import i18n from "@/locales"

export default function useI18n() {
  return {
    t: i18n.global.t,
    tc: i18n.global.tc
  }
}